<div class="policy-links">
  <div class="policy-links__head policy-links__head--advisor">
    <h3 class="policy-links__title policy-links__title--advisor">Your Financial Professional</h3>
  </div>
  <div class="policy-links__advisor-name">
    <span>{{ advisorName }}</span>
  </div>
  <ng-container>
    <div class="policy-links__row policy-links__row--top">
      <a class="text-link text-link--underline text-link--advisor" target="_blank" href="mailto:{{ advisorEmail }}">
        {{ advisorEmail }}
      </a>
    </div>
    <div class="policy-links__row policy-links__row--top">
      <a class="text-link text-link--underline text-link--advisor" target="_blank" href="tel:{{ advisorPhone }}">
        {{ advisorPhone }}
      </a>
    </div>
  </ng-container>
</div>
